export default __webpack_public_path__ + "static/media/common_gnust_preview.4344c7ca.png";